import { render, staticRenderFns } from "./DueDiligenceStartups.vue?vue&type=template&id=fbab90f2&scoped=true"
import script from "./DueDiligenceStartups.vue?vue&type=script&lang=js"
export * from "./DueDiligenceStartups.vue?vue&type=script&lang=js"
import style0 from "./DueDiligenceStartups.vue?vue&type=style&index=0&id=fbab90f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbab90f2",
  null
  
)

export default component.exports